import { LocalVideoTrack, Participant, RemoteVideoTrack } from 'livekit-client';
import { ScreenShare } from 'features/ScreenShare';
import { useVideoQualityByParticipantCount } from 'hooks/useVideoQualityByParticipantCount';
import { StageProps } from '../types';
import { MainLayout, RecordStageLayout, SidebarLayout } from './view';
import { ParticipantsList } from './components/ParticipantsList/ParticipantsList';

type RecordScreenShareStageProps = StageProps & {
    participants: Participant[];
    screenTrack: LocalVideoTrack | RemoteVideoTrack;
};

export const RecordScreenShareStage = ({ participants, screenTrack, roomState }: RecordScreenShareStageProps) => {
    useVideoQualityByParticipantCount();

    return (
        <RecordStageLayout>
            <MainLayout>
                <ScreenShare track={screenTrack} isAuthorShown />
            </MainLayout>
            <SidebarLayout>
                <ParticipantsList participants={participants} room={roomState.room} />
            </SidebarLayout>
        </RecordStageLayout>
    );
};
